/* MY RITUAL LAB — mrl-theme.js — vanilla, zéro dépendance, zéro app */
(function () {
  'use strict';
  var d = document;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- Drawers (menu + panier) ---------- */
  function bindDrawer(id) {
    var dr = $(id);
    if (!dr) return null;
    function open() { dr.classList.add('is-open'); d.body.style.overflow = 'hidden'; }
    function close() { dr.classList.remove('is-open'); d.body.style.overflow = ''; }
    $$('.mrl-drawer__bg,[data-drawer-close]', dr).forEach(function (el) { el.addEventListener('click', close); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return { open: open, close: close };
  }
  var menuDrawer = bindDrawer('#MrlMenuDrawer');
  var cartDrawer = bindDrawer('#MrlCartDrawer');
  $$('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { menuDrawer && menuDrawer.open(); }); });
  $$('[data-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (!$('#MrlCartDrawer')) return;
      e.preventDefault(); renderCart(); cartDrawer.open();
    });
  });

  /* ---------- Panier AJAX ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }
  function renderCart() {
    var wrap = $('#MrlCartItems');
    if (!wrap) return;
    fetchCart().then(function (cart) {
      updateCount(cart.item_count);
      var foot = $('#MrlCartFoot');
      if (!cart.items.length) {
        wrap.innerHTML = '<div class="mrl-cart__empty">Votre panier est vide.</div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = '';
      $('#MrlCartTotal').textContent = money(cart.total_price);
      wrap.innerHTML = cart.items.map(function (it) {
        return '<div class="mrl-cart__item" data-key="' + it.key + '">' +
          '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') : '') + '" alt="">' +
          '<div><div class="b">' + (it.vendor || '') + '</div><div class="t">' + it.product_title + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="d" style="font-size:11px;color:#8E8E8E">' + it.variant_title + '</div>' : '') +
          '<div class="mrl-cart__qty"><button data-qty="-1" aria-label="Réduire">−</button><span>' + it.quantity + '</span><button data-qty="1" aria-label="Augmenter">+</button></div></div>' +
          '<div style="font-family:var(--mrl-disp);font-weight:600;font-size:13px">' + money(it.final_line_price) + '</div></div>';
      }).join('');
      $$('[data-qty]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var row = b.closest('.mrl-cart__item');
          var qty = parseInt($('.mrl-cart__qty span', row).textContent, 10) + parseInt(b.dataset.qty, 10);
          fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: row.dataset.key, quantity: Math.max(0, qty) })
          }).then(renderCart);
        });
      });
    });
  }
  fetchCart().then(function (c) { updateCount(c.item_count); });

  function addToCart(variantId, btn) {
    var initial = btn ? btn.textContent : '';
    var qty = 1;
    if (btn && btn.dataset.qty) { qty = Math.max(1, parseInt(btn.dataset.qty, 10) || 1); }
    if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      if (btn) { btn.textContent = 'Ajouté ✓'; btn.classList.add('is-done'); }
      if ($('#MrlCartDrawer')) { renderCart(); cartDrawer.open(); }
      else { fetchCart().then(function (c) { updateCount(c.item_count); }); }
      setTimeout(function () {
        if (btn) { btn.textContent = initial; btn.classList.remove('is-done'); btn.disabled = false; }
      }, 1800);
    }).catch(function () {
      if (btn) { btn.textContent = initial; btn.disabled = false; }
      window.location.href = '/cart';
    });
  }
  /* Délégation : tous les boutons carte + fiche */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-atc]');
    if (!b) return;
    e.preventDefault();
    addToCart(b.dataset.atc, b);
  });

  /* ---------- Fiche produit : variantes + prix dans le bouton ---------- */
  var pform = $('[data-product-form]');
  if (pform) {
    var variants = JSON.parse($('#MrlVariants').textContent);
    function currentVariant() {
      var opts = $$('.mrl-pdp__vals input:checked', pform).map(function (i) { return i.value; });
      return variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
    }
    function refresh() {
      var v = currentVariant();
      var btn = $('[data-atc-main]', pform);
      var priceEl = $('[data-atc-price]', pform);
      var cmpEl = $('[data-atc-compare]', pform);
      if (!v || !v.available) {
        btn.disabled = true;
        priceEl.textContent = v ? 'Épuisé' : 'Indisponible';
        if (cmpEl) cmpEl.textContent = '';
      } else {
        btn.disabled = false;
        btn.dataset.atc = v.id;
        priceEl.textContent = money(v.price);
        if (cmpEl) cmpEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      }
      var st = $('#MrlStickyPrice');
      if (st && v) st.textContent = money(v.price);
    }
    $$('.mrl-pdp__vals input', pform).forEach(function (i) { i.addEventListener('change', refresh); });
    refresh();

    /* Sticky ATC mobile : visible quand le bouton principal sort de l'écran */
    var sticky = $('#MrlStickyAtc');
    var mainBtn = $('[data-atc-main]', pform);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('is-visible', !en[0].isIntersecting);
      }, { threshold: 0 }).observe(mainBtn);
      $('[data-atc-sticky]', sticky).addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(mainBtn.dataset.atc, mainBtn);
      });
    }
  }

  /* ---------- Galerie produit ---------- */
  var gal = $('[data-gallery]');
  if (gal) {
    var slides = $('.mrl-gal__slides', gal);
    var thumbs = $$('.mrl-gal__thumbs button', gal);
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
      });
    });
    slides.addEventListener('scroll', function () {
      var i = Math.round(slides.scrollLeft / slides.clientWidth);
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', i === j); });
    }, { passive: true });
  }

  /* ---------- Hero slideshow ---------- */
  $$('[data-slideshow]').forEach(function (sh) {
    var track = $('.mrl-hero__track', sh);
    var n = track.children.length;
    if (n < 2) { $$('.mrl-hero__arrow', sh).forEach(function (a) { a.remove(); }); return; }
    var i = 0, timer;
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
    }
    function auto() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 6000); }
    $('[data-next]', sh).addEventListener('click', function () { go(i + 1); auto(); });
    $('[data-prev]', sh).addEventListener('click', function () { go(i - 1); auto(); });
    auto();
  });

  /* ---------- Onglets best sellers ---------- */
  $$('[data-tabs]').forEach(function (root) {
    var btns = $$('[role="tab"]', root);
    var panels = $$('.mrl-tabpanel', root);
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, j) { x.setAttribute('aria-selected', i === j); });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      });
    });
  });

  /* ---------- Sous-collections « voir plus » ---------- */
  $$('[data-showmore]').forEach(function (b) {
    b.addEventListener('click', function () {
      var g = $(b.dataset.showmore);
      g.classList.add('is-open');
      b.remove();
    });
  });

  /* ---------- Load more collection ---------- */
  var lm = $('[data-loadmore]');
  if (lm) {
    lm.addEventListener('click', function () {
      var next = lm.dataset.next;
      if (!next) return;
      lm.textContent = 'Chargement…';
      fetch(next).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('#MrlCollGrid');
        $$('#MrlCollGrid > *', doc).forEach(function (c) { grid.appendChild(c); });
        var nb = doc.querySelector('[data-loadmore]');
        if (nb && nb.dataset.next) {
          lm.dataset.next = nb.dataset.next;
          lm.textContent = nb.textContent;
        } else { lm.closest('.mrl-loadmore').remove(); }
        var cnt = $('[data-coll-count]');
        var ncnt = doc.querySelector('[data-coll-count]');
        if (cnt && ncnt) cnt.textContent = ncnt.textContent;
      });
    });
  }

  /* ---------- Wishlist localStorage ---------- */
  var WKEY = 'mrl_wishlist';
  function wishlist() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function syncHearts() {
    var list = wishlist();
    $$('[data-wish]').forEach(function (b) {
      b.classList.toggle('is-on', list.indexOf(b.dataset.wish) > -1);
    });
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var list = wishlist();
    var h = b.dataset.wish;
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    localStorage.setItem(WKEY, JSON.stringify(list));
    syncHearts();
  });
  syncHearts();

  /* ---------- Flèches des carrousels ---------- */
  $$('[data-rail-prev],[data-rail-next]').forEach(function (b) {
    b.addEventListener('click', function () {
      var rail = $('[data-rail]', b.closest('section'));
      if (!rail) return;
      var card = rail.firstElementChild;
      var step = card ? card.offsetWidth + 18 : 300;
      rail.scrollBy({ left: b.hasAttribute('data-rail-next') ? step : -step, behavior: 'smooth' });
    });
  });
})();